export const svgsArr = [
    [
        {
        "fps_limit": 28,
        "particles": {
            "collisions": {
                "enable": false
            },
            "number": {
                "value": 300,
                "density": {
                    "enable": false
                }
            },
            "line_linked": {
                "enable": true,
                "distance": 60,
                "opacity": 0.2
            },
            "move": {
                "speed": .3
            },
            "opacity": {
                "anim": {
                    "enable": true,
                    "opacity_min": 0.5,
                    "speed": 1,
                    "sync": false
                },
                "value": 0.4
          },
          "size": {
            "value": 3,
            "random": true,
            "anim": {
            "enable": true,
            "speed": 2,
            "size_min": 0.15,
            "sync": false
            }
          }
        },
        "polygon": {
            "enable": true,
            "scale": 1.9,
            "type": "inline",
            "move": {
                "radius": 7
            },
            "url": "PolygonMaskImages/cassette-tape.svg",
            "inline": {
                "arrangement": "equidistant"
            },
            "draw": {
                "enable": false,
                "stroke": {
                    "color": "rgba(255, 255, 255, .2)"
                }
            }
        },
        "retina_detect": false,
        "interactivity": {
            "events": {
                "onhover": {
                    "enable": true,
                    "mode": "bubble"
                }
            },
            "modes": {
                "bubble": {
                    "size": 6,
                    "distance": 50
                }
            }
        }
    },{
		background: "linear-gradient( 74.3deg,  rgba(68,17,28,1) 17.4%, rgba(95,24,40,1) 34.7%, rgba(122,31,51,1) 51.8%, rgba(149,38,62,1) 67.4%, rgba(163,41,68,1) 89.6% )",
		animation:"background-fade-in-and-out 40s",
		animationDelay: "0s" 
    }],
    [{
    "fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 200,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 55,
					"opacity": 0.2
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.1,
						"speed": 1,
						"sync": false
					},
					"value": 1
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale": 2.7,
				"type": "inline",
				"move": {
					"radius": 8
				},
				"url": "PolygonMaskImages/orange.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": false,
					"stroke": {
						"color": "rgba(255, 255, 255, .2)"
					}
				}
			},
			"retina_detect": false,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
	
				},
				"modes": {
					"bubble": {
						"size": 5,
						"distance": 300
					},
					"repulse": {
						"distance": 70
					}
				}
				
            }
        },{background: "radial-gradient( circle farthest-corner at 78% 59.3%,  rgba(255,104,104,1) 0%, rgba(230,127,41,1) 90% )", animation:"background-fade-in-and-out 40s",
		animationDelay: "0s" }],
        [{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 200,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 80,
					"opacity": 0.2
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 2.9,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale": 6,
				"type": "inline",
				"move": {
					"radius": 7
				},
				"url": "PolygonMaskImages/brokenheart.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .35)"
					}
				}
			},
			"retina_detect": false,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 40
					}
				}
			}
        },{
			background: "radial-gradient( circle farthest-corner at 50% 50%,  rgb(138, 12, 155) 0%, rgb(26, 25, 25) 100.2% )",
			animation:"background-fade-in-and-out 40s",
			animationDelay: "15s"
		}],
        [{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 200,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 60,
					"opacity": 0.2
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale": 3.7,
				"type": "inline",
				"move": {
					"radius": 8
				},
				"url": "PolygonMaskImages/ayana3.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .2)"
					}
				}
			},
			"retina_detect": false,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 90
					}
				}
			}
		},{
			background: 'radial-gradient( circle 861px at 9.5% 19.8%,  rgba(116,247,129,0.5) 0%, rgba(167,248,175,0.5) 4.5%, rgba(216,253,224,.5) 90% )',
			animation:"background-fade-in-and-out 45s",
		animationDelay: "8s"},],
        [{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 200,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 60,
					"opacity": 0.1
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale": 7,
				"type": "inline",
				"move": {
					"radius": 8
				},
				"url": "PolygonMaskImages/pamm.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .2)"
					}
				}
			},
			"retina_detect": true,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 90
					}
				}
			}
        },{background: "linear-gradient( 179.2deg,  rgba(34,34,34,.5) 0%, rgba(8,0,153,.5) 29.7%, rgba(118,6,166,.5) 63.4%, rgba(233,0,64,0.5) 100.1% )", animation:"background-fade-in-and-out 45s",
		animationDelay: "7s"}],
        [{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 250,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 80,
					"opacity": 0.2
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale":2.5,
				"type": "inline",
				"move": {
					"radius": 7
				},
				"url": "PolygonMaskImages/deer2.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .5)"
					}
				}
			},
			"retina_detect": true,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 90
					}
				}
			}
		},{background: "radial-gradient( circle farthest-corner at 49.4% 49.5%,  rgba(42,98,20,1) 0.1%, rgba(18,36,5,1) 100.2% )", animation:"background-fade-in-and-out 45s",
		animationDelay: "17s"},{ marginLeft: "9vw", marginTop: "-6vh"}], [{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 250,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 80,
					"opacity": 0.3
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale":16,
				"type": "inline",
				"move": {
					"radius": 7
				},
				"url": "PolygonMaskImages/sunset.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .2)"
					}
				}
			},
			"retina_detect": true,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 90
					}
				}
			}
		},{background: 'linear-gradient( 179.9deg,  rgba(141,154,190,.7) 1.9%, rgba(244,179,78,.7) 39.6%, rgba(235,124,88,.7) 61.5%, rgba(235,124,88,.7) 75%, rgb(19, 5, 18,.7) 93% )', animation:"background-fade-in-and-out 45s",
		animationDelay: "4s"},{marginTop:"7vh"}],
		[
			{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 300,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 60,
					"opacity": 0.2
				},
				"move": {
					"speed": .2
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale": 1.35,
				"type": "inline",
				"move": {
					"radius": 7
				},
				"url": "PolygonMaskImages/whale.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .2)"
					}
				}
			},
			"retina_detect": false,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 50
					}
				}
			}
		},{
			background: 'radial-gradient( circle 801px at 4.2% 16.4%,  rgba(104,211,218,0.5) 0%, rgba(184,77,235,.5) 88.8% )',
			animation:"background-fade-in-and-out 40s",
			animationDelay: "0s" 
		}],
		[{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 200,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 80,
					"opacity": 0.2
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale":2.2,
				"type": "inline",
				"move": {
					"radius": 7
				},
				"url": "PolygonMaskImages/virgo.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": false,
					"stroke": {
						"color": "rgba(255, 255, 255, .5)"
					}
				}
			},
			"retina_detect": true,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 90
					}
				}
			}
		},{background: "linear-gradient( 138deg,  rgba(32,201,255,.6) 36.7%, rgba(0,8,187,.6) 84.4%, rgba(255,255,255,.6) 119.7% )", animation:"background-fade-in-and-out 45s",
		animationDelay: "10s"},{ marginLeft: "12vw", marginTop: "6vh"}],
		[{
			"fps_limit": 28,
			"particles": {
				"collisions": {
					"enable": false
				},
				"number": {
					"value": 250,
					"density": {
						"enable": false
					}
				},
				"line_linked": {
					"enable": true,
					"distance": 70,
					"opacity": 0.15
				},
				"move": {
					"speed": .3
				},
				"opacity": {
					"anim": {
						"enable": true,
						"opacity_min": 0.5,
						"speed": 1,
						"sync": false
					},
					"value": 0.4
			  },
			  "size": {
				"value": 3,
				"random": true,
				"anim": {
				"enable": true,
				"speed": 2,
				"size_min": 0.15,
				"sync": false
				}
			  }
			},
			"polygon": {
				"enable": true,
				"scale":2.5,
				"type": "inline",
				"move": {
					"radius": 7
				},
				"url": "PolygonMaskImages/seed-of-life.svg",
				"inline": {
					"arrangement": "equidistant"
				},
				"draw": {
					"enable": true,
					"stroke": {
						"color": "rgba(255, 255, 255, .5)"
					}
				}
			},
			"retina_detect": true,
			"interactivity": {
				"events": {
					"onhover": {
						"enable": true,
						"mode": "bubble"
					}
				},
				"modes": {
					"bubble": {
						"size": 6,
						"distance": 90
					}
				}
			}
		},{background: "linear-gradient(-225deg, rgba(93, 159, 255, 0.5) 0%, rgba(177, 159, 255, 0.5) 48%, rgba(236, 161, 254, 0.5) 100%)", animation:"background-fade-in-and-out 45s",
		animationDelay: "8s"},{ marginLeft: "14vw", marginTop: "0vh"}]
];